/**
 * Calculate experience duration from a given start date to today
 * Returns a formatted string like "2 tahun 3 bulan" or "5 bulan"
 * @param joinDate - The date when the member joined (ISO string or Date)
 * @returns Formatted experience string
 */
export function calculateExperience(joinDate: string | Date | null | undefined): string {
  if (!joinDate) return '';
  
  const start = new Date(joinDate);
  const now = new Date();
  
  // Handle invalid dates
  if (isNaN(start.getTime())) return '';
  
  // Calculate difference in months
  let months = (now.getFullYear() - start.getFullYear()) * 12;
  months -= start.getMonth();
  months += now.getMonth();
  
  // Adjust for day of month
  if (now.getDate() < start.getDate()) {
    months--;
  }
  
  // Handle negative (future dates)
  if (months < 0) return '';
  
  const years = Math.floor(months / 12);
  const remainingMonths = months % 12;
  
  if (years === 0) {
    if (remainingMonths === 0) return 'Baru bergabung';
    if (remainingMonths === 1) return '1 bulan';
    return `${remainingMonths} bulan`;
  }
  
  if (remainingMonths === 0) {
    if (years === 1) return '1 tahun';
    return `${years} tahun`;
  }
  
  const yearStr = years === 1 ? '1 tahun' : `${years} tahun`;
  const monthStr = remainingMonths === 1 ? '1 bulan' : `${remainingMonths} bulan`;
  
  return `${yearStr} ${monthStr}`;
}
